import React, { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import auth0Config from './constant/auth0-config';

interface Auth0ProviderWithHistoryProps {
  children: ReactNode;
}

const Auth0ProviderWithHistory: React.FC<Auth0ProviderWithHistoryProps> = ({
  children,
}) => {
  const history = useHistory();

  // Back from Auth0, land on the page (and ?order= link) the user asked for.
  const onRedirectCallback = (appState: AppState | undefined) => {
    history.replace(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId!}
      /*
       * Tokens stay in memory in production, which is the safer default: nothing readable from
       * localStorage, and a refresh silently re-mints the token against the Auth0 session cookie
       * without the user seeing anything.
       *
       * That silent round trip is the one thing that cannot work locally. Auth0 refuses to skip
       * the consent screen for a localhost callback, so the silent check comes back
       * consent_required and the SDK falls back to a full redirect - the Authorize App prompt, on
       * every single refresh. Caching in localStorage during development sidesteps it by not
       * making the round trip at all.
       *
       * CRA sets NODE_ENV to development for `yarn start` and production for `yarn build`.
       */
      cacheLocation={
        process.env.NODE_ENV === 'development' ? 'localstorage' : 'memory'
      }
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
